import { INIT_ROOT } from '../actionTypes';

export default function disclosures(state, action) {
  switch (action.type) {
    case INIT_ROOT:
      return action.payload.appResources.disclaimers.reduce(function(
        hash,
        disclosure
      ) {
        hash[disclosure.ss] = disclosure.label;
        return hash;
      },
      {});
    default:
      return state || {};
  }
}
